module.exports = "<div class=\"content-wrapper p-0\" [dir]=\"direction\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n"